import ShareASale from './ShareASale';

export default ShareASale;
